// The Maps JS API is loaded once by the layout <script> tag. google-map-react's
// default loader injects a second copy (without a key) when it mounts before
// that async script finishes, which breaks the map on first page load.
const POLL_INTERVAL_MS = 50;
const TIMEOUT_MS = 15000;

let pending = null;

const mapsReady = () => window.google && window.google.maps && window.google.maps.Map;

const loadGoogleMaps = () => {
  if (mapsReady()) {
    return Promise.resolve(window.google.maps);
  }

  if (!pending) {
    pending = new Promise((resolve, reject) => {
      const startedAt = Date.now();
      const check = () => {
        if (mapsReady()) {
          resolve(window.google.maps);
        } else if (Date.now() - startedAt > TIMEOUT_MS) {
          pending = null;
          reject(new Error('Google Maps JS API did not load'));
        } else {
          setTimeout(check, POLL_INTERVAL_MS);
        }
      };
      check();
    });
  }

  return pending;
};

export default loadGoogleMaps;
